import React, { Component } from 'react'
import Header from '@/components/Header'
import MetaDetail from '../../components/_common/MetaDetail'
import Form from "@/components/_common/Form";
import TextField from "@/components/_common/Form/inputs/TextField";
import Dob from "@/components/_common/Form/inputs/Dob";
import Select from "@/components/_common/Form/inputs/Select";
//import Checkbox from "#/components/_common/Form/inputs/Checkbox";
import tracking from '../../utils/tracking'
import './competition.scss'
import countries from "@/data/countries.json";
import validateForm from "@/components/_common/Form/validate";
import TextArea from '../../components/_common/Form/inputs/TextArea';
import Checkbox from "@/components/_common/Form/inputs/Checkbox";
import { post } from "@/utils/api";


class CompetitionPage extends Component {
	state = {
		fields: {
		  first_name: { value: "", showError: false },
		  last_name: { value: "", showError: false },
		  email: { value: "", showError: false },
		  country: { value: "IE", showError: false },
		  dob: { day: "", month: "", year: "", showError: false },
		  paragraph:{value:"",showError:false,limit:500},
		  terms_of_use:{value:false,showError:false},
		  subscribe_brand_news_optional:{value:false,showError:false}
		},
		submitSuccess:false
	  };
	


	componentDidMount() {
		tracking.pageView('/competition')
	}

	onFormChange = (value, name, key = "value") => {
		console.log(value,name,key)
		if(name!="country"){
			this.setState(state => (state.fields[name][key] = value));
		}
		
	};

	onSubmit = async () => {
		
		
	
		const { fields } = this.state;
		const data = {};
	
		Object.keys(fields).forEach(key => {
			data[key] = fields[key].value || (key == "subscribe_brand_news_optional" ? false : "")
		});

		data.dob = `${fields.dob.year}-${fields.dob.month}-${fields.dob.day}`;
		data.promocode = "DWE000OGB1120BA0006"

		try {
		  	const response = await post(data, "submit-comp");
			if (response.error) {
				if (response.error === "under_18") {
						tracking.event("customEvent", {
							eventCategory: "Sign Up Form",
							eventAction: "error",
							eventLabel: `under 18, source: ${
							this.props.routeProps.location.pathname
						}`
					});
					return alert("You must be 18 or over");
				}
		
				tracking.event("customEvent", {
				eventCategory: "Sign Up Form",
				eventAction: "error",
				eventLabel: `${response.error}, source: ${
					this.props.routeProps.location.pathname
				}`
				});
				return alert(response.error);
			  }
			  
			  //Success 
			  this.setState({submitSuccess:true});
	
		} catch (e) {
		  tracking.event("customEvent", {
			eventCategory: "Sign Up Form",
			eventAction: "error",
			eventLabel: `${e}, source: ${this.props.routeProps.location.pathname}`
		  });
		  alert(e);
		  console.error(e);
		}
	  };

	  
	render() {

		let items = [
			{
				header: 'SO, WHAT’S INCLUDED?',
				copy: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
				color: "blue"
			},
			{
				header: 'HOW TO WIN? ',
				copy: 'Simply tell us your favourite beer and food pairing to be in with a chance to win.',
				copyBottom:'Please note: Entrants must be 18 years or older and residents of Ireland.',
				color: "red"
			},
		]
		return (
			<div className='welcome' >
				<Header />
				<div className='welcome-page'>
					{/* <MetaDetail  /> */}
					<div className={'hero hero--active'}>
						<div className={'feature feature--active'}>
							<div className={'hero__container'}>
								<div className={'hero__background theuselessbrew'} />
								<div className={'hero__heading-container'}>
									<div className={'hero__text-container sweepstakes-heading-container'}>
										<h1 className={'hero__subhead sweepstakes-subhead'}>
										WIN A LOREM IPSUM
										
										</h1>
									</div>
								</div>
							</div>
						</div>
						<div className='hero--waves' />
					</div>
					{items && items.map((item, i) => {
						return (
							<div className={'feature feature--active welcome__container'}>
								<div className={`welcome-item__wrap ${i % 2 === 0 ? 'image-right' : 'image-left'} welcome-item__bg--${item.color}`}>
									<div className={'welcome-item__text-container'}>
										<h2 className={'welcome-item__name'}>{item.header}</h2>
										<div className={'welcome-item__separator'} />
										<div className={'welcome-item__desc'} dangerouslySetInnerHTML={{__html: item.copy}} />
										<div className={'welcome-item__desc-bottom'} style={{marginTop:'40px'}} dangerouslySetInnerHTML={{__html: item.copyBottom}} />
									</div>
									{/* <div className={'welcome-item__image-container'} style={`background-image: url('${item.img}'); background-position: center; background-repeat: no-repeat; background-size: cover`} /> */}
								</div>
							</div>

						)
					})
					}
					
					{!this.state.submitSuccess ? 
						<Form className="sign-up-form" >
							
							<TextField
								label="Your first name*"
								name="first_name"
								id="firstName"
								placeholder="ENTER YOUR FIRST NAME"
								field={this.state.fields.first_name}
								onChange={this.onFormChange}
							/>

							<TextField
								label="Your last name*"
								name="last_name"
								id="lastName"
								placeholder="ENTER YOUR LAST NAME"
								field={this.state.fields.last_name}
								onChange={this.onFormChange}
							/> 
							<TextField
								label="Your email*"
								name="email"
								id="email"
								placeholder="ENTER YOUR EMAIL"
								field={this.state.fields.email}
								onChange={this.onFormChange}
								errorMessage="*Please enter a valid email address"
							/>
							

							<h3 className="form__label">Your date of birth*</h3>
							<Dob
								name="dob"
								field={this.state.fields.dob}
								onChange={this.onFormChange}
							/>
							<TextArea
							
								label="WHAT IS YOUR FAVOURITE BEER AND FOOD PAIRING (MAX. 500 CHARACTERS) * "
								name="paragraph"
								id="paragraph"
								
								field={this.state.fields.paragraph}
								onChange={this.onFormChange}
								errorMessage={this.state.fields.paragraph.showError}
							
							/>
							<Select
								label="Your country of residence*"
								placeholder="SELECT YOUR COUNTRY"
								name="country"
								id="country"
								options={countries.filter((country)=>country.name=="IRELAND")}
								field={this.state.fields.country}
								onChange={this.onFormChange}
							/>
							<Checkbox
								
								name="terms_of_use"
								id="terms_of_use"
								field={this.state.fields.terms_of_use}
								onChange={this.onFormChange}
								errorMessage="*Please check the box above if you would like to proceed"
								hrefs={
									<span>
										I accept the <b><u><a href={"/terms-and-conditions"} target='_blank'>
            							competition terms and conditions</a></u></b>  and <b><u><a href={"https://footer.diageohorizon.com/dfs/assets/www.guinnessopengate.com/TnC_en.html?locale=en-ie"} target='_blank'>
        								website conditions of use</a></u></b> 
									</span>
								}
							/>
							
							<Checkbox
								label="Tick here if you would like to receive special offers and news about Guinness by emai. You can unsubscribe at any time."
								name="subscribe_brand_news_optional"
								id="subscribe_brand_news_optional"
								field={this.state.fields.subscribe_brand_news_optional}
								onChange={this.onFormChange}
								errorMessage="*Please check the box above if you would like to proceed"
							/>


							<p style={{marginTop:'20px',fontSize:'1.4rem'}}>
								Guinness values and respects your privacy. Please see our  
								<b>&nbsp;<u><a href="https://footer.diageohorizon.com/dfs/assets/www.diageo.com/PrivacyPolicy_en.html?locale=en-gb" target="_blank">Privacy and Cookie</a></u></b>  for more information.
							</p>
							

							<button
								className="cta cta--lg-font form__cta"
								onClick={() =>
									this.setState(
										validateForm("Competition Form", this.props.routeProps, this.onSubmit)
									)
								}
							>
								ENTER NOW
							</button>

						</Form>

						:
						<div style={{marginTop:'100px',paddingBottom:'50px',textAlign:'center'}}>
							<h1>Thank you, your submission has been accepted!</h1>
						</div>
						
					}
						
						
				</div>
			</div >
		)
	}
}

// 	export default connect(
//   () => ({}),
// 	{buildContentAction}
// ) (WelcomePage);
export default CompetitionPage



// WEBPACK FOOTER //
// ./src/pages/competition/index.js